import { IFeatureFlags, IUserInfoApi } from '@common/interfaces';
import AxiosRepository from './axios.repository';

export interface IAccountRepository {
  getFeatureFlags: () => Promise<IFeatureFlags>;
  getUser: () => Promise<IUserInfoApi>;
}

class AccountRepository extends AxiosRepository implements IAccountRepository {
  async getFeatureFlags() {
    const { data } = await this.get('/feature-flags/');

    return data;
  }

  async getUser() {
    const { data } = await this.get('/accounts/me/');

    return data;
  }
}

export default AccountRepository;
